<div *ngFor="let notification of notifications" class="notification-container" [class]="notification.type.toLowerCase()">
    <div class="notification-header" (click)="openNotificationLink($event, notification)">
        <ng-container [ngSwitch]="notification.type">
            <h1 *ngSwitchCase="notificationTypeEnum.SUCCESS">
                <mat-icon>check_circle_outlined</mat-icon>
                <span> {{ notification.title ?? 'Success' }}</span>
            </h1>
            <h1 *ngSwitchCase="notificationTypeEnum.ERROR">
                <mat-icon>error</mat-icon>
                <span> {{ notification.title ?? 'Error' }}</span>
            </h1>
            <h1 *ngSwitchCase="notificationTypeEnum.WARNING">
                <mat-icon class="material-icons-round">warning_amber</mat-icon>
                <span> {{ notification.title ?? 'Warning' }}</span>
            </h1>
            <h1 *ngSwitchCase="notificationTypeEnum.INFO">
                <mat-icon>info_outlined</mat-icon>
                <span> {{ notification.title ?? 'Info' }}</span>
            </h1>
        </ng-container>
        <p>{{ notification.message }}</p>
    </div>

    <button [attr.aria-label]="notification.message" (click)="dismiss($event, notification)">
        <mat-icon>clear</mat-icon>
    </button>
</div>
